import type { OrderPackage, TemperatureMode } from './types';
import type { IconName } from '../components/icons';

/** Počty balíků objednávky po teplotních režimech. */
export interface TempComposition {
  ambient: number;
  chilled: number;
  frozen: number;
}

/** Prototyp, objekt TEMPS. Barva je teal – záměrně mimo zelenou, modrou i amber. */
export interface TempStyle {
  icon: IconName;
  bg: string;
  ink: string;
}

export const TEMP_STYLE: Record<Exclude<TemperatureMode, 'AMBIENT'>, TempStyle> = {
  CHILLED: { icon: 'therm', bg: '#E6F7FA', ink: '#0B5567' },
  FROZEN: { icon: 'snow', bg: '#0E7490', ink: '#FFFFFF' },
};

/**
 * Pás se vizuálně řídí NEJSTRIKTNĚJŠÍM přítomným režimem (spec 5):
 * jakmile je v zásilce byť jeden mražený balík, pás je plný teal s vločkou.
 * Skladník má zacházet s celou zásilkou podle nejnáročnějšího kusu, ne podle průměru.
 */
/**
 * Složení objednávky z pole balíků. Balík bez známého režimu se nezapočítá
 * nikam – radši nižší číslo ve výpisu než vymyšlený režim.
 */
export function composition(packages: OrderPackage[]): TempComposition {
  const out: TempComposition = { ambient: 0, chilled: 0, frozen: 0 };
  for (const p of packages) {
    if (p.temperature === 'AMBIENT') out.ambient++;
    else if (p.temperature === 'CHILLED') out.chilled++;
    else if (p.temperature === 'FROZEN') out.frozen++;
  }
  return out;
}

export function strictestMode(
  own: TemperatureMode | null,
  composition: TempComposition | null,
): Exclude<TemperatureMode, 'AMBIENT'> | null {
  if (composition && composition.frozen > 0) return 'FROZEN';
  if (composition && composition.chilled > 0) return 'CHILLED';
  if (own === 'FROZEN' || own === 'CHILLED') return own;
  return null;
}
